module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/gift-5804dd04c08ef0f13d47a17c99b83041.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/gift.svg
// module id = otoN
// module chunks = 24